import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { FilterService } from '../services/filter.service';
import { Subscription } from 'rxjs';
import { CheckboxComponent, SingleSelectListComponent, SingleSelectDropdownComponent } from '@cumlaude/shared-components-inputs';
import { Option, SchooljaarHistorieOption } from '@cumlaude/shared-utils';
import { find } from 'lodash-es';
import { FilterComponent } from '../filters/filter-component';
import { FilterName } from '../services/filter-name';

@Component({
	selector: 'app-schooljaar-historie-filter',
	templateUrl: './schooljaar-historie-filter.component.html',
	styleUrls: ['./schooljaar-historie-filter.component.scss'],
	imports: [SingleSelectListComponent, CheckboxComponent, SingleSelectDropdownComponent],
})
export class SchooljaarHistorieFilterComponent
	implements OnInit, OnDestroy, FilterComponent<{ option: SchooljaarHistorieOption; inclHuidig: boolean }>
{
	protected readonly filterService = inject(FilterService);

	allOptions = Object.values(SchooljaarHistorieOption).map(this.mapToDropDownOption.bind(this));

	filterName!: FilterName;
	inDropdown!: boolean;
	readonly searchInput = signal<string | undefined>(undefined);

	currentOption!: SchooljaarHistorieOption;
	inclHuidig = true;

	protected subscriptions: Subscription[] = [];

	ngOnInit() {
		this.subscriptions.push(
			this.filterService.getFilterStateAsInput(this.filterName).subscribe(({ option, inclHuidig }) => {
				this.currentOption = option;
				this.inclHuidig = inclHuidig;
			})
		);
	}

	getSelected(): Option<SchooljaarHistorieOption> {
		return find(this.allOptions, (option) => option.value === this.currentOption)!;
	}

	selectOption(option: SchooljaarHistorieOption) {
		this.currentOption = option;
		this.filterService.setFilterInput(this.filterName, { option, inclHuidig: this.inclHuidig });
	}

	selectHuidig(inclHuidig: boolean) {
		this.inclHuidig = inclHuidig;
		this.filterService.setFilterInput(this.filterName, { option: this.currentOption, inclHuidig });
	}

	protected mapToDropDownOption(option: SchooljaarHistorieOption): Option<SchooljaarHistorieOption> {
		return new Option<SchooljaarHistorieOption>(option);
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) sub.unsubscribe();
	}
}
